import React, { useState } from "react";

function fmtDuration(months) {
  if (!months) return "";
  if (months % 12 === 0) {
    const y = months / 12;
    return `${y} year${y !== 1 ? "s" : ""}`;
  }
  return `${months} month${months !== 1 ? "s" : ""}`;
}

export default function StepPlan({ products, onSelect, onBack }) {
  const [loading, setLoading] = useState(null);

  const active = (products || []).filter((p) => p.active !== false);

  const handleSelect = async (product) => {
    setLoading(product.id);
    await onSelect(product);
    setLoading(null);
  };

  return (
    <>
      <h2 className="step-title">Choose a Plan</h2>
      <p className="step-sub">Select the membership that's right for you.</p>

      {active.length === 0 && (
        <div className="su-alert info">
          No membership plans are currently available. Please contact the venue.
        </div>
      )}

      <div className="plan-grid">
        {active.map((product) => (
          <button
            key={product.id}
            className="plan-card"
            type="button"
            onClick={() => handleSelect(product)}
            disabled={loading !== null}
          >
            <div className="plan-info">
              <div className="plan-name">{product.name}</div>
              {product.description && (
                <div className="plan-desc">{product.description}</div>
              )}
              {product.duration_months > 0 && (
                <div className="plan-duration">
                  ⏱ {fmtDuration(product.duration_months)} membership
                </div>
              )}
            </div>
            <div style={{ textAlign: "right", flexShrink: 0 }}>
              <div className="plan-price">
                ${(product.price_cents / 100).toFixed(2)}
              </div>
              <div className="plan-currency">
                {(product.currency || "aud").toUpperCase()}
              </div>
            </div>
          </button>
        ))}
      </div>

      <button
        type="button"
        className="su-btn su-btn-outline su-btn-full"
        onClick={onBack}
        disabled={loading !== null}
      >
        ← Back
      </button>
    </>
  );
}
